package ru.villawonka.app.platform.di

import org.koin.dsl.module
import ru.villawonka.app.getLogger
import ru.villawonka.app.getPlatform
import ru.villawonka.app.getSentry
import ru.villawonka.app.getTelegram
import ru.villawonka.app.platform.Logger
import ru.villawonka.app.platform.Sentry
import ru.villawonka.app.platform.platform.Platform
import ru.villawonka.app.platform.telegram.Telegram

val platformModule = module {
    single<Platform> { getPlatform() }
    single<Logger?> { getLogger() }
    single<Telegram?> { getTelegram() }
    single<Sentry?> { getSentry() }
}